import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		gallery: [],
		cmp_gallery_1: [],
		cmp_gallery_2: [],
		gps: null, // {vehicle_id, from, to}

		attachments: [],

		hover: null,
		hoverAlign: 'left',
		hoverType: null,
		update: 0,
		app: null,
		windowStack: null,
		popupController: null,
		auth: null,
		roles: {
			employee: 	[],
			vehicle: 	[],
			all: 		[]
		},
		tasks: [],
		settings: {
			branding: {
				lead: 'mover'
			}
		},
		employee: {
			id: null,
			department_id: null,
			name: '',
			_links: {
				photo_48x48: {
					href: null
				}
			},
			_embedded: {
				departments: []
			}
		},
		departments: [],
		department: {
			id: null,
			label: ''
		}
	},
	mutations: {
		gallery(state, images) {
			state.gallery = images;
		},

		cmp_gallery_1(state, images) {
			state.cmp_gallery_1 = images;
		},

		cmp_gallery_2(state, images) {
			state.cmp_gallery_2 = images;
		},

		gps(state, gps) {
			state.gps = gps;
		},

		hover(state, pl) {
			state.hover = pl[0];
			state.hoverAlign = pl[1];
			state.hoverType = pl[2];

			
		},
		increment(state) {
			state.count++
		},

		employee(state, employee) {
			state.employee = employee;

			// Store as well
		},

		departments(state, departments) {
			state.departments = departments;
		},

		department(state, department) {
			state.department = department;
		},

		update(state) {
			state.update++;
		},

		auth(state, auth) {
			state.auth = auth;
		},
		set_employee_roles(state, roles) {
			state.roles.employee = roles;
			state.roles.all = [].concat(state.roles.employee, state.roles.vehicle);
		},
		set_vehicle_roles(state, roles) {
			state.roles.vehicle = roles;
			state.roles.all = [].concat(state.roles.employee, state.roles.vehicle);
		},
		set_settings(state, settings) {
			state.settings = Object.assign({}, state.settings, settings);
		},
		set_tasks(state, tasks) {
			state.tasks = tasks;
		}
	},
	actions: {
		async update_roles({ commit }, axios) {
			const r = await Promise.all([
				axios.get('/employees/roles/'),
				axios.get('/fleet/vehicles/roles/')
			]);

			commit('set_employee_roles',	r[0].data._items);
			commit('set_vehicle_roles',		r[1].data._items);
		},
		async update_settings({ commit }, axios) {
			commit('set_settings', (await axios.get('/us/settings/')).data);
		},
		async update_tasks({ commit }, axios) {
			commit('set_tasks', (await axios.get('/tasks/types/')).data._items);
		},
		async update({ dispatch }, axios) {
			dispatch('update_roles', axios);
			dispatch('update_tasks', axios);
			dispatch('update_settings', axios);
		},
	},
	getters: {
		tasks(state) {
			return state.tasks.reduce((prev, cur) => {
				prev[cur.name] = cur;
				return prev;
			}, {});
		},
		taskTypes(state) {
			if ('tasks' in state.settings) return state.settings.tasks;
			return ["move","transport","export","music","bus","survey","pickup","delivery","pack","unpack","discard","it_down","it_up","handy","handling","cleaning","storage","barricade","conf","free"];
		},
		leadRole(state) {
			const role = state.roles.employee.find(role => {
				return role.name == state.settings.branding.lead;
			});

			if (role) return role;

			return {
				"name":"mover",
				"label":"Flyttemand",
				"plural":"Flyttemænd",
				"props":[
				   {
					  "label":"Sikkerhedsgodkendt",
					  "name":"security_approved",
					  "type":"SwitchView",
					  "default":false
				   },
				   {
					  "label":"Kørekort B (Alm. bil, max 3.500 kg)",
					  "name":"license_b",
					  "type":"SwitchView",
					  "default":false
				   },
				   {
					  "label":"Kørekort B+ (Alm. bil, over 3.500 kg)",
					  "name":"license_b_plus",
					  "type":"SwitchView",
					  "default":false
				   },
				   {
					  "label":"Kørekort C1 (Lille lastbil, max 7.500 kg)",
					  "name":"license_c1",
					  "type":"SwitchView",
					  "default":false
				   },
				   {
					  "label":"Kørekort C (Stor lastbil)",
					  "name":"license_c",
					  "type":"SwitchView",
					  "default":false
				   },
				   {
					  "label":"Kørekort D1 (Lille bus, max 16 pers)",
					  "name":"license_d1",
					  "type":"SwitchView",
					  "default":false
				   },
				   {
					  "label":"Kørekort D (Stor bus)",
					  "name":"license_d",
					  "type":"SwitchView",
					  "default":false
				   },
				   {
					  "label":"Kørekort E (Stort påhængskøretøj)",
					  "name":"license_e",
					  "type":"SwitchView",
					  "default":false
				   },
				   {
					  "label":"Gaffeltruck Certifikat B",
					  "name":"certificate_truck_b",
					  "type":"SwitchView",
					  "default":false
				   }
				]
			 };
		}
	}
});